<template>
  <el-card v-loading="loading">
    <el-table :data="unitRentals">
      <el-table-column label="Name" prop="unit.name">
      </el-table-column>
      <el-table-column label="MoveIn">
        <template slot-scope="scope">
          {{ scope.row.moveIn | formatDate }}
        </template>
      </el-table-column>
      <el-table-column label="MoveOut">
        <template slot-scope="scope">
          <span v-if="scope.row.moveOut">
            {{  scope.row.moveOut | formatDate }}
          </span>
          <span v-else>Not set</span>
        </template>
      </el-table-column>
      <el-table-column label="Price">
        <template slot-scope="scope">
          {{ Number(scope.row.pricing.price).toLocaleString('en', { style: 'currency', currency: scope.row.pricing.currency }) }}
        </template>
      </el-table-column>
      <el-table-column label="Status" prop="unit.status" :formatter="(row, column, cellValue) => $options.filters.printableStatus(cellValue)">
      </el-table-column>
    </el-table>
  </el-card>
</template>

<script>
import axios from 'axios';
import { UNIT_RENTAL_API_BASE } from '../env';

export default {
  name: 'CustomerLeaseView',
  props: {
    customerInvoices: { type: Array, default: () => [] },
    active: { type: Boolean, default: true },
  },
  watch: {
    async customerInvoices() {
      this.loading = true;
      this.unitRentals = await this.getUnitRentalsByInvoice();
      this.loading = false;
    },
  },
  async mounted() {
    this.loading = true;
    this.unitRentals = await this.getUnitRentalsByInvoice();
    this.loading = false;
  },
  data() {
    return {
      lease: {},
      units: [],
      unitRentals: [],
      loading: false,
    };
  },
  computed: {
    activeLease() {
      return this.customerInvoices && this.customerInvoices.length ? this.customerInvoices[0] : null;
    },
  },
  methods: {
    async getUnitRentalsByInvoice() {
      if (this.activeLease) {
        const response = await axios.get(`${UNIT_RENTAL_API_BASE}`, {
          params: {
            unitInvoice: this.activeLease._id,
          },
          headers: {
            Authorization: `Bearer ${this.$keycloak.token}`,
          },
        });
        return response.data.result;
      }
      return [];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/CustomerLeaseView.vue